import { FC, useCallback, useState } from 'react'

import { Button } from '../Buttons'
import { Icon, IconName, IconSize } from '../Icon'
import { Layer } from '../Layer'
import { SidePanel } from '../SidePanel'
import { FeedbackPanelContent } from './FeedbackPanelContent'

import { s } from './styles'

export interface FeedbackWidgetProps {
  contentPage: string
}

export const FeedbackWidget: FC<FeedbackWidgetProps> = ({ contentPage }) => {
  const [isOpened, setIsOpened] = useState(false)

  const handleOpen = useCallback(() => {
    setIsOpened(true)
  }, [])

  const handleClose = useCallback(() => {
    setIsOpened(false)
  }, [])

  return (
    <>
      <Layer rounded shadowed stretch style={{ marginTop: '14px' }}>
        <s.TriggerWrapper>
          <s.TriggerText>What was difficult or confusing on this page?</s.TriggerText>
          <s.TriggerButtonWrapper>
            <Button face="tertiary" onClick={handleOpen} data-qa="feedback-trigger">
              <div>
                <Icon name={IconName.OUTLINE_STAR} size={IconSize.S} />
                Give Feedback
                <Icon name={IconName.OUTLINE_STAR} size={IconSize.S} />
              </div>
            </Button>
          </s.TriggerButtonWrapper>
        </s.TriggerWrapper>
      </Layer>

      <SidePanel
        isOpened={isOpened}
        content={<FeedbackPanelContent contentPage={contentPage} onClose={handleClose} />}
        onOpenClose={(opened) => {
          if (!opened) {
            handleClose()
          }
        }}
      />
    </>
  )
}
